import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage } from '../../generic/generic.manage';
import { AssetType } from '../../../model/api/assets/asset-type';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AssetTypeHttpService } from '../../../services/http/assets/asset-type.http.service';

@Component({
    selector: 'app-asset-type-manage',
    templateUrl: 'asset-type.manage.html',
    providers: [ AssetTypeHttpService ]
})
export class AssetTypeManageComponent extends GenericManage<AssetType, number> {

    @ViewChild('itemDetailModal') modal: ModalDirective;

    isCollapsed: boolean = true;
    public filter: string = '';

    constructor(public assetTypeHttpService: AssetTypeHttpService) {
        super();
    }

    public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public exportToExcel(){

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.assetTypeHttpService.get(1, 10000000, 'code', 'asc', params, null).subscribe(
            (data: PagedResult<AssetType>) => {

                let options = {
                    sheetid: 'clase',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql.promise(`SELECT id as [Id], 
                //                     code as [Cod], 
                //                     name as [Denumire], 
                //                     depPeriodMin as [Durata minima], 
                //                     depPeriodMax as [Durata maxima], 
                //                     depPeriodDefault as [Durata implicita] 
                //                     INTO XLSX("clase.xlsx", ?) FROM ?`, [ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
